import { render } from "./burgerNavTree.vue?vue&type=template&id=2489a56e"
import script from "./burgerNavTree.vue?vue&type=script&lang=js"
export * from "./burgerNavTree.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__